import { useTranslation } from "react-i18next";

/**
 * Mobile menu links configuration
 */
const GetMobileMenuLinks = () => {
  const { t } = useTranslation();

  return [
    { name: t("navigation.browse"), path: "/categories" },
    { name: t("navigation.my_courses"), path: "/my-courses" },
    { name: t("navigation.contact"), path: "/contact" },
  ];
};

export default GetMobileMenuLinks;
